<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {}
  },
  created() {
    window.APP = this
    document.body.id = "body"
  },
  methods: {
    //...mapActions("translationModule", ["getTranslation"]),
  }
}
</script>
